import CrudApi from "@serie3/common/api/crudApi";
import { SetupAssistantConfig } from "../endpoints";
import GetContentPillarsDTO from "../Entity/GetContentPillarsDTO";

const createGetContentPillarsDTOForm = (setPillars) => {
  const onSubmit = async (values) => {
    let payload = JSON.stringify(values, null, 2);
    const response = await CrudApi.createNew(SetupAssistantConfig.endpoints.getContentPillars, payload);
    if (response.status === 200) {
        setPillars(response.data.topics);
    }
  };

  return {
    initialValues: GetContentPillarsDTO,
    onSubmit: (values, actions) => {
      onSubmit(values);
    },
  };
};



export default { createGetContentPillarsDTOForm };
